import React from 'react'

import audio from './../../../../UI/canvasMobile/sidebar/audio.svg'
import audioOff from './../../../../UI/canvasMobile/sidebar/audioOff.svg'
import volante from './../../../../UI/canvasMobile/sidebar/volante.svg'
import compra from './../../../../UI/canvasMobile/sidebar/compra.svg'
import cotiza from './../../../../UI/canvasMobile/sidebar/cotiza.svg'
import vehiculos from './../../../../UI/canvasMobile/sidebar/vehiculos.svg'
import datos from './../../../../UI/canvasMobile/sidebar/datos.svg'
import fullscreen from './../../../../UI/canvasMobile/sidebar/fullscreen.svg'
import star from './../../../../UI/canvasMobile/topMenu/star_blue.svg'

import logoUmbra from './../../../../UI/canvas/umbra-logo-grey.svg'

import { categoryData as CData } from './../../../../data/category.data';
import { familyData as FData } from './../../../../data/family.data';
import {individualData as IData} from './../../../../data/individual.data';

interface Props{
    selectedCategory: string,
    selectedFamily: string,
    selectedIndividual: string,
    handleSelectedCategory: any
    handleSelectedFamily: any,
    handleSelectedIndividual: any,
    isSidebarOpened: any,
    handleOpenBar: any,
    handleVehiculosMobile: any
    handleCategoryMobile: any
    handleFamilyMobile: any,
    handleFullScreen: any
    handleAudio: any
    isMuted: any,
    handleOpenSurvey: any
}

interface State{
    isMainOpened: boolean,
    currentInfoLevel: string,
    CategoryData: any,
    FamilyData: any,
    IndividualData: any,
    iOSDevice: boolean
}

declare const window: any;


class SidebarMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            isMainOpened: true,
            currentInfoLevel: "Vehículos",
            CategoryData: CData(),
            FamilyData: FData(),
            IndividualData: IData(),
            iOSDevice: false
        }
    }

    componentDidMount(){
        this.setState({
            iOSDevice: this.handleIOSDevice()
        })
    }

    handleIOSDevice = () => {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
          ].includes(navigator.platform)
          // iPad on iOS 13 detection
          || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    handleOpenVehiclesInfo = () => {
        this.setState({
            isMainOpened: false
        })
    }

    handleGetCategory = () => {
        return(
            this.state.CategoryData.map((data: any, index: number) =>
                <div 
                    className='individual-category-container-mobile' 
                    key = {index} 
                    onClick={() => {this.props.handleSelectedCategory(this.props.selectedCategory === data.Nombre ? "":data.Nombre)}}
                >
                    <img src={data.Imagen}></img>
                    <div className={this.props.selectedCategory === data.Nombre ? 'text-category-mobile':'text-category-mobile'}>{data.Nombre}</div>
                </div>
            )
        )
    }

    handleGetFamily = () => {
        if(this.props.selectedCategory !== ""){
            return(
                this.state.FamilyData[0][this.props.selectedCategory].map((data: any, index: number) =>
                    <div 
                        className='individual-category-container-mobile' 
                        key={index} 
                        onClick={() => {this.props.handleSelectedFamily(this.props.selectedFamily === data.Nombre ? "":data.Nombre)}}
                        id='element-umbra-analytics' data-value={data.Nombre} data-type={"MODELO"}
                    >
                        <img id='element-umbra-analytics' data-value={data.Nombre} data-type={"MODELO"} src={data.Imagen}></img>
                        <div id='element-umbra-analytics' data-value={data.Nombre} data-type={"MODELO"} className={this.props.selectedFamily === data.Nombre ? 'text-category-mobile':'text-category-mobile'}>{data.Nombre}</div>
                    </div>
                )
            )
        }
    }

    handleGetIndividual = () => {
        if(this.props.selectedFamily !== "" && this.props.selectedCategory !== "HÍBRIDOS" && this.props.selectedCategory !== "PERFORMANCE"){
            return(
                this.state.IndividualData[0][this.props.selectedFamily + " " +this.props.selectedCategory].map((data: any, index: number) =>
                    <div 
                        className='individual-category-container-mobile' 
                        key={index}
                        onClick={() => {this.props.handleSelectedIndividual(this.props.selectedIndividual === data.Nombre ? "":data.Nombre)}}
                        id='element-umbra-analytics' data-value={this.props.selectedFamily} data-second={data.Nombre} data-type={"VERSION"} 
                    >
                        <img id='element-umbra-analytics' data-value={this.props.selectedFamily} data-second={data.Nombre} data-type={"VERSION"}  src={data.Imagen}></img>
                        <div id='element-umbra-analytics' data-value={this.props.selectedFamily} data-second={data.Nombre} data-type={"VERSION"}  className={this.props.selectedIndividual === data.Nombre ? 'text-category-mobile':'text-category-mobile'}>{data.Nombre}</div>
                    </div>
                )
            )
        }
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isSidebarOpened ? 'sidebar-main-mobile-opened':'sidebar-main-mobile' }
            style={{
                pointerEvents : this.props.isSidebarOpened ? "visibleFill":"none"
            }}>
                <div 
                    className={this.props.isSidebarOpened ? 'sidebar-btn-opened-mobile':'sidebar-btn-mobile'} 
                    onClick={() => {this.props.handleOpenBar()}}
                    style = {{pointerEvents: "all"}}
                >
                    <div className={this.props.isSidebarOpened ? 'top-bar-opened-mobile':'top-bar-collapsed-mobile'}/>
                    <div className={this.props.isSidebarOpened ? 'middle-bar-opened-mobile':'middle-bar-collapsed-mobile'}/>
                    <div className={this.props.isSidebarOpened ? 'bottom-bar-opened-mobile':'bottom-bar-collapsed-mobile'}/>
                </div>
                {
                    <React.Fragment>
                        <div className={this.props.isSidebarOpened  ? 'sidebar-mainbar-opened fade-in':'sidebar-mainbar-opened fade-out'}>
                            <div className='sidebar-mobile-item'></div>
                            <hr/>

                            <div className='sidebar-mobile-item' onClick={() => {this.handleOpenVehiclesInfo()}}>
                                <img src={vehiculos}></img>
                            </div>
                            <hr/>
                            <a 
                                href={"https://www.ford.com.co/cotiza/?&leadsource=VS"}
                                target="_blank"
                                onClick = {
                                    () => {
                                        window.paramsObj = {
                                            "section-menus": "GENERAL"+">"+"COTIZADOR",
                                                    };
                                        window.ym(88905571, "params", window.paramsObj || {})
                                    }
                                }
                            >
                            <div className='sidebar-mobile-item'>
                                <img src={cotiza}></img>
                            </div>
                            </a>
                            {/* <a 
                                href={"https://www.ford.com.co/compra/?&leadsource=VS"}
                                target="_blank"
                                onClick = {
                                    () => {
                                        window.paramsObj = {
                                            "section-menus": "GENERAL"+">"+"COMPRA REMOTA",
                                                    };
                                        window.ym(88905571, "params", window.paramsObj || {})
                                    }
                                }
                            >
                                <div className='sidebar-mobile-item'>
                                    <img src={compra}></img>
                                </div>
                            </a> */}
                            <a 
                                href="https://www.ford.com.co/test-drive/?&leadsource=VS"
                                target={"_blank"}
                                onClick = {
                                    () => {
                                        window.paramsObj = {
                                            "section-menus": "GENERAL"+">"+"TEST DRIVE",
                                                    };
                                        window.ym(88905571, "params", window.paramsObj || {})
                                    }
                                }
                            >
                                <div className='sidebar-mobile-item'>
                                    <img src={volante}></img>
                                </div>
                            </a>
                            <hr/>

                            { !this.state.iOSDevice ? 
                                <div className='sidebar-mobile-item' onClick={this.props.handleFullScreen}>
                                    <img src={fullscreen}></img>
                                </div>: null
                            }
                            
                            <div className='sidebar-mobile-item' onClick={() => {this.props.handleAudio()}}>
                                <img src={this.props.isMuted ? audioOff:audio}></img>
                            </div>
                            <a href='https://www.ford.com.co/politica-tratamiento-datos/' target={"_blank"}>
                                <div className='sidebar-mobile-item'>
                                    <img src={datos}></img>
                                </div>
                            </a>
                            <hr/>
                            <div className='sidebar-mobile-item' onClick={() => {
                                window.paramsObj = {
                                    "section-menus": "GENERAL"+">"+"CALIFICACIÓN",
                                            };
                                window.ym(88905571, "params", window.paramsObj || {})
                                this.props.handleOpenSurvey(true)
                                }}>
                                    <img src={star}></img>
                            </div>
                            <hr/>
                        </div>
                        <div className={this.props.isSidebarOpened && this.state.isMainOpened ? 'sidebar-secondarybar-opened fade-in':'sidebar-secondarybar-opened fade-out'}>
                            <div className='sidebar-mobile-item'>
                                <div className='individual-container-menu'>
                                    Menú
                                </div>
                            </div>
                            <hr/>

                            <div className='sidebar-mobile-item' onClick={() => {this.handleOpenVehiclesInfo()}}>
                                <div className='individual-container-alt'>
                                    Vehículos
                                </div>
                            </div>
                            <hr/>

                            <a
                                href={"https://www.ford.com.co/#overlay/content/ford/co/es_co/site-wide-content/overlays/forms/request-a-quote.html?&leadsource=VS"}
                                target="_blank"
                                id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"}
                            >
                            <div id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"} className='sidebar-mobile-item'>
                                <div id='element-umbra-analytics' data-value={"Cotiza"} data-type={"INTERFAZ"} className='individual-container-alt'>
                                    Cotiza
                                </div>
                            </div>
                            </a>
                          {/*  <a
                            href={"https://www.ford.com.co/#overlay/content/ford/co/es_co/site-wide-content/overlays/forms/customer-update.html?&leadsource=VS"}
                            target="_blank"
                            id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"}
                           >
                            <div id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"} className='sidebar-mobile-item'>
                                    <div id='element-umbra-analytics' data-value={"Compra remota"} data-type={"INTERFAZ"} className='individual-container-alt'>
                                        Compra remota
                                    </div>
                                </div>
                           </a> */}
                            <a
                                href={"https://www.ford.com.co/#overlay/content/ford/co/es_co/site-wide-content/overlays/forms/test-drive.html?&leadsource=VS"}
                                target={"_blank"}
                                id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"}
                            >
                            <div id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"} className='sidebar-mobile-item'>
                                <div id='element-umbra-analytics' data-value={"Test drive"} data-type={"INTERFAZ"} className='individual-container-alt'>
                                    Test drive
                                </div>
                            </div>
                            </a>
                            <hr/>

                            {!this.state.iOSDevice ? 
                                <div className='sidebar-mobile-item' onClick={this.props.handleFullScreen}>
                                    <div className='individual-container-alt'>
                                        Full Screen
                                    </div>
                                </div>:null
                            }
                            <div className='sidebar-mobile-item' onClick={() => {this.props.handleAudio()}}>
                                <div className='individual-container-alt'>
                                    Audio {this.props.isMuted ? "OFF":"ON"}
                                </div>
                            </div>
                            <div className='sidebar-mobile-item'>
                                <div className='individual-container-alt'>
                                    Política de datos
                                </div>
                            </div>
                            <hr/>
                            <div className='sidebar-mobile-item' onClick={() => {this.props.handleOpenSurvey(true)}}>
                                <div className='individual-container-alt'>
                                    ¡Califícanos!
                                </div>
                            </div>
                            <hr/>
                        </div>
                    </React.Fragment>
                }
                {
                    <div className={!this.state.isMainOpened && this.props.isSidebarOpened ? 'sidebar-vehiculos-mobile fade-in':'sidebar-vehiculos-mobile fade-out'}>
                        <div className='sidebar-mobile-item'>
                            <div className='individual-container-menu-centered'>
                                {this.state.currentInfoLevel}
                            </div>
                        </div>
                        <hr/>
                        <div className='sidebar-mobile-item-levels'>
                            <div className='individual-level-container'>
                                <div className='level-vehiculos' onClick={() => {this.props.handleVehiculosMobile()}}><div>VEHÍCULOS</div><div>{">"}</div></div>
                                {
                                    this.props.selectedCategory ? <div className='level-category' onClick={() => {this.props.handleCategoryMobile()}}> <div> {this.props.selectedCategory} </div><div> {'> '}</div></div>:null
                                }
                            </div>
                            {
                                this.props.selectedFamily ?
                                <div className='individual-level-container'>
                                    {
                                        this.props.selectedFamily ? <div className='level-family'><div> {this.props.selectedFamily} </div><div> {'> '}</div></div>:null
                                    }
                                    {/*
                                        this.props.selectedIndividual ? <div className='level-individual'>{this.props.selectedIndividual}</div>:null
                                    */}
                                </div>: null
                            }
                        </div>
                        <hr/>
                        <div className='sidebar-car-container-mobile'>
                            <div className='sidebar-car-container-indivibiduals-container'>
                                <div className={this.props.isSidebarOpened && this.props.selectedCategory === "" && !this.state.isMainOpened ? 'category-container-mobile fade-in':'category-container-mobile fade-out'}>
                                    {
                                        this.handleGetCategory()
                                    }
                                </div>
                                <div className={ 
                                    (this.props.isSidebarOpened && this.props.selectedCategory !== "" && this.props.selectedFamily === "")||
                                    (this.props.isSidebarOpened &&  (this.props.selectedCategory === "PERFORMANCE" || this.props.selectedCategory === "HÍBRIDOS"))
                                    ? 'family-container-mobile fade-in':'family-container-mobile fade-out'}>
                                    {
                                        this.handleGetFamily()
                                    }
                                </div>

                                <div 
                                    className={this.props.isSidebarOpened && this.props.selectedFamily  && this.props.selectedCategory !== "HÍBRIDOS" && this.props.selectedCategory !== "PERFORMANCE" ? 'info-container-individual-mobile fade-in':'info-container-individual-mobile fade-out'}
                                    onClick={() => {this.props.handleSelectedFamily("")}}
                                >
                                        <div className='info-category-mobile' onClick={() => {this.props.handleSelectedFamily("")}}>
                                            {this.props.selectedFamily !== "" ? this.props.selectedFamily : ""}
                                        </div>
                                </div>
                                <div className={this.props.isSidebarOpened && this.props.selectedFamily !== "" && this.props.selectedCategory !== "HÍBRIDOS" && this.props.selectedCategory !== "PERFORMANCE" ? 'individual-container-mobile fade-in':'individual-container-mobile fade-out'}>
                                    {
                                        this.handleGetIndividual()
                                    }
                                </div>
                            </div>
                            <div className={this.props.isSidebarOpened ? 'umbra-logo-container-mobile fade-in':'umbra-logo-container-mobile fade-out'}>
                            <div className='umbra-text-mobile'>
                                    Powered by:
                                </div>
                                <a href="https://umbraint.com/" target={"_blank"}><img src={logoUmbra}/></a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

export default SidebarMobile